import MuiGrid from '@mui/material/Grid';

import { styled } from 'helpers';

import { Props } from './types';

// Bit of a hack to retain 'component' prop.
// https://github.com/mui-org/material-ui/issues/15695#issuecomment-498242520
export const Grid = styled(MuiGrid)<Props>`` as typeof MuiGrid;
// @ts-ignore
Grid.displayName = 'Grid';

export default Grid;
